import {createSelector} from 'reselect';

const getAutoProfileState = (state) => state.autoProfileState;

export const getShowPauseToRefillModal = createSelector(
  [getAutoProfileState],
  (autoProfileState) => autoProfileState.showPauseToRefillModal,
);

export const getIsPauseHandled = createSelector(
  [getAutoProfileState],
  (autoProfileState) => autoProfileState.isPauseHandled,
);
